module.exports = __webpack_public_path__ + "img/acorn-sky-cropped.0aca904f.jpg";